import _ from 'underscore';
import { getGridFilter } from '@bingads-webui-campaign/inline-download-grids-metadata';

export const setFilterByReportEmailRule = ({
  appConfig,
  filterService,
  ReportEmailRule,
}) => {
  const permissions = (appConfig && appConfig.get('permissions')) || {};
  const { dynamic: { ColumnConversion: IsColumnConversionEnabled } = {} } = permissions;

  if (!ReportEmailRule) {
    return filterService.p$Initialized;
  }

  let filter = null;

  if (ReportEmailRule.Filter) {
    filter = JSON.parse(ReportEmailRule.Filter);
  } else {
    filter = getGridFilter(ReportEmailRule.Entity, ReportEmailRule.Selection);
  }

  if (_.isEmpty(filter)) {
    filter = null;
  }

  const originalPromise = filterService.p$Initialized;

  return originalPromise
    .then(() => {
      if (filterService.p$Initialized !== originalPromise) {
        // refreshSource is called, need to wait for its completion
        return filterService.p$Initialized;
      }
      return null;
    })
    .then(() => {
      filterService.deserialize(
        JSON.stringify(filter),
        IsColumnConversionEnabled
      );
      return filterService.p$Initialized;
    });
};
